import React, { useEffect, useCallback } from 'react';
import { Box, ButtonBase, Typography, Icon } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import { useAppointments } from '../context';

import SectionCard from '../../../components/SectionCard';
import useStyles from './styles';
import Loading from './Loading';

const AboutAppointments = () => {
  const classes = useStyles();
  const history = useHistory();
  const { infos } = useAppointments();

  const createMarkup = useCallback(() => ({ __html: infos.html }), [
    infos.html,
  ]);

  useEffect(() => {
    if (infos?.loaded && !infos?.html) {
      history.replace('appointments/history');
    }
  }, [history, infos]);

  return !infos.loaded ? (
    <Loading />
  ) : (
    <Box className={classes.container}>
      <SectionCard className="about-text-container">
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={createMarkup()} />
      </SectionCard>
      <ButtonBase
        className="btn-new-appointment"
        to="/appointments/new"
        component={Link}
      >
        <Icon className="btn-new-appointment-icon-before">schedule</Icon>
        <Typography
          className="btn-new-appointment-text"
          variant="button"
          noWrap
        >
          Agendar horário
        </Typography>
        <Icon className="btn-new-appointment-icon-after">chevron_right</Icon>
      </ButtonBase>
    </Box>
  );
};

export default AboutAppointments;
